import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import format from 'string-template';
import { Tooltip } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

import { DateFormat } from '../../../../../../utils/date';
import {
  Container,
  RowContainer,
  NoteCredit,
  Separator,
  StyledTypography,
  ColumnContainer,
  StrongTypography,
  NoteText,
  StyledDate,
  TitleRow,
  StyledInfoIcon,
} from './styles';
import texts from './texts';

const CoachNote = ({
  value,
  actionInfo,
  infoTooltip,
  note,
  date,
  name,
}) => {
  const momentDate = moment(date);
  const dateDifference = momentDate.fromNow();

  return (
    <Container>
      <RowContainer>
        <StyledDate>
          {momentDate.format(DateFormat.DATE_MONTH_TIME_SHORT_DISPLAY_FORMAT)}
        </StyledDate>
        <Separator>
          {texts.separator}
        </Separator>
        <ColumnContainer>
          <TitleRow>
            <StyledTypography>
              {value}
            </StyledTypography>
            {!!infoTooltip && (
              <Tooltip
                title={infoTooltip}
                placement="top"
                arrow
              >
                <StyledInfoIcon>
                  <InfoOutlined fontSize="inherit" />
                </StyledInfoIcon>
              </Tooltip>
            )}
          </TitleRow>
          {!!actionInfo && (
            <NoteText>{actionInfo}</NoteText>
          )}
          {!!note && (
            <NoteText>{format(texts.note, { note })}</NoteText>
          )}
          <NoteCredit>
            <StrongTypography>
              {dateDifference}
            </StrongTypography>
            {format(texts.userName, { name })}
          </NoteCredit>
        </ColumnContainer>
      </RowContainer>
    </Container>
  );
};

CoachNote.propTypes = {
  value: PropTypes.string.isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
  name: PropTypes.string.isRequired,
  actionInfo: PropTypes.string,
  infoTooltip: PropTypes.node,
  note: PropTypes.string,
};

CoachNote.defaultProps = {
  actionInfo: '',
  infoTooltip: null,
  note: '',
};

export default CoachNote;
